module.exports = __webpack_public_path__ + "static/posthuman3-9ca22eaa16d3d06ee6d25ac18617e5b2.jpg";